export const PHONE = {
  PSEUDO_START: 320,
  END: 599,
}

export const SMALL_PHONE = {
  END: 374,
}

export const MEDIUM_PHONE = {
  START: 375,
  END: 414,
}

export const LARGE_PHONE = {
  START: 415,
  END: 599,
}

export const TABLET = {
  START: 600,
  END: 1023,
}

export const SMALL_TABLET = {
  START: 600,
  END: 767,
}

export const MEDIUM_TABLET = {
  START: 768,
  END: 1023,
}

export const DESKTOP = {
  START: 1024,
}

export const SMALL_DESKTOP = {
  START: 1024,
  END: 1359,
}

export const MEDIUM_DESKTOP = {
  START: 1360,
  END: 1919,
}

export const LARGE_DESKTOP = {
  START: 1920,
}

// Authentication
export const MIN_PASSWORD_CHAR_LENGTH = 6

// Date Formats
export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD'

// Event Manager
export const DAY_CUTOFF_FOR_ADDING_PARTICIPANTS = 10
export const DAY_CUTOFF_TO_ADD_REMOVE_ITEMS = 21
export const DAY_CUTOFF_TO_REQUEST_EXTENSION = 14
export const DAY_CUTOFF_TO_RETURN_PURCHASE = 30
export const MAX_PRODUCT_DISPLAY_COUNT = 5

// Event Status
export const EVENT_BOOKED = 'booked'
export const EVENT_IN_PROGRESS = 'in progress'
export const EVENT_PAST = 'past'

// Existing Email Error
export const EXISTING_EMAIL_WRONG_PASSWORD_ERROR =
  "You already have an account but the password wasn't right."

// Forms
export const MIN_AUTOCOMPLETE_CHAR_LENGTH = 3
export const TEL_PATTERN = '[0-9]*' // can be used for inputting whole numbers or telephone numbers

// Product
export const EVENT_TYPE_ALL = 'all events'
export const EVENT_TYPE_LIST = ['All Events', 'Wedding', 'Prom', 'Special Event']
export const EVENT_TYPE_PROM = 'Prom or Formal'
export const EVENT_TYPE_SPECIAL = 'A different special event'
export const EVENT_TYPE_WEDDING = 'Wedding'
export const HTO_CATEGORIES = ['suits-tuxedos', 'suits', 'tuxedos', 'shirts', 'vests', 'neckwear-2']
export const NUMBER_OF_FEATURED_REVIEWS = 3
export const PRODUCT_NAME_LINE_BREAK = 28
export const REVIEWS_PER_PAGE = 25
export const SCORE_TYPE_ALL = 'all ratings'
export const SUIT_TUX_GROUP = ['suits', 'tuxedos']

// Reviews
export const HALF_STAR_START = 0.25
export const HALF_STAR_END = 0.75

// REDUX object holds the names of each redux form, so it can be referenced
//  consistently throughout the codebase.
export const REDUX = {
  ACCOUNT_INFO_PASSWORD_FORM: 'AccountInfoPasswordForm',
  ACCOUNT_INFO_USER_FORM: 'AccountInfoUserForm',
  ACCOUNT_PASSWORD_RESET_FORM: 'AccountPasswordResetForm',
  ADD_PARTICIPANT_FORM: 'AddParticipantForm',
  ADDRESS_UPDATE_FORM: 'AddressUpdateForm',
  CHECKOUT_BILLING_FORM: 'CheckoutBillingForm',
  CHECKOUT_PARTNER_FORM: 'CheckoutPartnerForm',
  CHECKOUT_REVIEW_FORM: 'CheckoutReviewForm',
  CHECKOUT_SHIPPING_FORM: 'CheckoutShippingForm',
  EDIT_PARTICIPANT_EMAIL_FORM: 'EditParticipantEmailForm',
  EXCHANGE_FLOW_FORM: 'ExchangeFlowForm',
  LOGIN_FORM: 'LoginForm',
  PASSWORD_RESET_REQUEST_FORM: 'PasswordResetRequestForm',
  REGISTRATION_FORM: 'RegistrationForm',
  RTK_BILLING_FORM: 'RentToKeepBillingForm',
}

export const PAGINATION_SET = {
  DESKTOP: 5,
  MOBILE: 3,
}

// addToLook Origin Values
export const ATL_ORIGIN_RECOMMENDATION_MODAL = 'crossSellModule'
export const ATL_ORIGIN_CTL = 'completeTheLook'
export const ATL_ORIGIN_HTO = 'hto'
export const ATL_ORIGIN_LB = 'lookbuilder'
export const ATL_ORIGIN_PDP = 'pdp'
export const ATL_ORIGIN_BUY_EXPERIMENT_PDP = 'buy experiment pdp'

// Transaction Types

export const TRANSACTION_TYPE_BUY = 'buy'
export const TRANSACTION_TYPE_HTO = 'hto'
export const TRANSACTION_TYPE_RENT = 'rent'
export const TRANSACTION_TYPE_RENT_ADD = 'rent_add'

export const EXPRESS_SHIPPING = 'express'
export const OVERNIGHT_SHIPPING = 'overnight'

export const PAYABLE_SHIPPING_METHODS = [EXPRESS_SHIPPING, OVERNIGHT_SHIPPING]

export const FIT_TYPE_LABEL_MAP = {
  C: 'Classic',
  S: 'Slim',
  XS: 'Extra Slim',
}

export const JACKETS_CATEGORY_SLUG = 'jackets'
export const PANTS_CATEGORY_SLUG = 'pants'
export const SHIRTS_CATEGORY_SLUG = 'shirts'
export const VESTS_CATEGORY_SLUG = 'vests'
export const SHOES_CATEGORY_SLUG = 'shoes'
export const BELTS_CATEGORY_SLUG = 'belts'

// MyTime: Currently required to map the state codes to the full name.
// Remove once MyTime provides us the extra field for full state name.
export const STATE_HASH = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

/**
 * Map of statuses representing the possible states of an API request.
 * @typedef {Object} states
 * @property {string} [states.IDLE]
 * @property {string} [states.PENDING]
 * @property {string} [states.SUCCESS]
 * @property {string} [states.ERROR]
 */
export const ApiRequestStates = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
}

// Category page filter params
export const CATEGORY_FILTER_PARAMS = {
  HTO: 'hto',
}

export const MEASURED_AT_DAVIDS_BRIDAL = 'davids-bridal'

/**
 * Locations for fitprofile measuredAt, where the value is what to send to the API to persist to the
 * database. We don't surface anything about this to the user, so this object is meant to just
 * ensure consistency when receiving and sending values to the API.
 * @typedef {Object} locations
 * @property {number} [locations.MEASURED_AT_DAVIDS_BRIDAL]
 *
 */
export const MEASURED_AT_LOCATIONS = {
  [MEASURED_AT_DAVIDS_BRIDAL]: '1',
}

/**
 * Enums for specifying the possible arrival days for a rental order
 *
 * @readonly
 * @enum {string}
 */
export const RENTAL_ARRIVAL_DAYS = Object.freeze({
  10: '10 days',
  12: '12 days',
  14: '14 days',
})

export const SELECTED_RENTAL_ARRIVAL_DAY = RENTAL_ARRIVAL_DAYS[10]
export const RETURN_POLICY_DAYS = 60
export const RENTAL_RETURN_DAYS = 3
export const SHIPPING_THRESHOLD = '$200'

export const BUY_PROMO_CODE = 'WEDDINGSEASON20'
export const IS_BUY_PROMO_ACTIVE = false
export const IS_PROMO_ACTIVE = false
